// src/components/forms/SignatureSection.jsx
import React, { useRef, useState } from 'react';
import {
    Box,
    Grid,
    Typography,
    Button,
    TextField,
} from '@mui/material';
import { useTheme } from '@mui/material/styles';
import SignaturePad from 'react-signature-canvas';

export default function SignatureSection() {
    const theme = useTheme();
    const sigPad = useRef(null);
    const [signed, setSigned] = useState(false);
    const [date, setDate] = useState(() => new Date().toISOString().slice(0, 10));
    const [printedName, setPrintedName] = useState('');

    const handleEnd = () => {
        if (sigPad.current && !sigPad.current.isEmpty()) {
            setSigned(true);
        }
    };

    const handleClear = () => {
        sigPad.current.clear();
        setSigned(false);
    };

    const formValid = signed && printedName.trim() !== '';

    return (
        <Box mb={4}>
            {/* SC DPH�branded gradient header */}
            <Box
                sx={{
                    mb: 2,
                    p: 1,
                    borderRadius: 1,
                    background: `linear-gradient(135deg, ${theme.palette.primary.main} 0%, ${theme.palette.secondary.main} 100%)`,
                }}
            >
                <Typography variant="h6" color="white">
                    Authorized Signature
                </Typography>
            </Box>

            <Grid container spacing={2}>
                {/* Date Signed */}
                <Grid item xs={12} sm={6}>
                    <TextField
                        label="Date Signed"
                        type="date"
                        fullWidth
                        InputLabelProps={{ shrink: true }}
                        value={date}
                        onChange={(e) => setDate(e.target.value)}
                    />
                </Grid>

                {/* Printed Name */}
                <Grid item xs={12} sm={6}>
                    <TextField
                        label="Printed Name"
                        fullWidth
                        value={printedName}
                        onChange={(e) => setPrintedName(e.target.value)}
                    />
                </Grid>

                {/* Signature Canvas */}
                <Grid item xs={12}>
                    <Box
                        sx={{
                            border: '1px solid',
                            borderColor: 'divider',
                            borderRadius: 1,
                            height: 200,
                        }}
                    >
                        <SignaturePad
                            ref={sigPad}
                            penColor="black"
                            canvasProps={{
                                width: 500,
                                height: 200,
                                style: { width: '100%', height: '100%' },
                            }}
                            onEnd={handleEnd}
                        />
                    </Box>
                </Grid>

                {/* Clear & Submit */}
                <Grid item xs={12} sm={6}>
                    <Button
                        variant="outlined"
                        fullWidth
                        onClick={handleClear}
                    >
                        Clear
                    </Button>
                </Grid>
                <Grid item xs={12} sm={6}>
                    <Button
                        variant="contained"
                        color="primary"
                        type="submit"
                        fullWidth
                        disabled={!formValid}
                    >
                        Submit
                    </Button>
                </Grid>
            </Grid>
        </Box>
    );
}
